import React from 'react';

const Career: React.FC = () => {
    return (
        <div className="container">
            <h1 className="text-center mb-4"><img src="/images/career.png" alt="Uma Shankar Security Agency Career" className="me-2" style={{width: '50px', height: '50px', borderRadius: '50%', border: '3px solid #8b9f3f'}} /> Career</h1>
            <p className="text-center mb-5">Get in touch with Uma Shankar Security Agency for professional security and manpower solutions</p>
            
            <div className="row">
                <div className="col-lg-1 col-centered"></div>
                <div className="col-lg-10 mb-4">
                    <div className="card h-100 border-success">
                        <div className="card-header bg-success text-white text-center">
                            <h4>We are hiring below jobs in urgent basis</h4>
                        </div>
                        <div className="card-body">
                            <div className="mb-3 text-center">
                                <h5 className="text-success">📧 email your resume to “career_usecurityagency@gmail.com”</h5>
                                <p>info.usecurityagency@gmail.com<br />contact.usecurityagency@gmail.com</p>
                            </div>
                            <div className="mb-3 text-center">
                                <h5 className="text-success">📍 Address</h5>
                                <p>Uma Shankar Security Agency<br />GF 153 Khazana Complex<br/>Ashiyana, Lucknow, (UP) ,226012<br/>📞 Office: 7415405250<br/>India</p>
                            </div>
                        </div>
                    </div>
                </div>
                
               
            </div>
        </div>
    );
};

export default Career;